import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TranslateService } from "@ngx-translate/core";

import { Equipment } from "@models/equipment.model";
import { Tooltip } from "primeng/tooltip";

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
    @ViewChild(Tooltip) tooltip!: Tooltip;

    @Input() displayType: string;
    @Input() record: any = {};
    @Input() dropdownContent: any = [];
    @Input() tooltipPosition: 'left' | 'right' | 'top' | 'bottom' | null = 'top';
    @Input() pulsating = false;
    @Input() escape = false;
    @Input() appendTo = 'body';
    @Input() positionLeft = 0;
    @Input() positionTop = 0;
    @Input() tooltipOffsetX = 0;
    @Input() tooltipOffsetY = 0;
    @Input() showDelay = 150;
    @Input() hideDelay = 500;
    @HostBinding('class') @Input() type: 'info' | 'warning' | 'important' | 'light' | 'dark' | 'success' | 'critical' | 'alert' = 'info';

    @Output() tooltipActions = new EventEmitter<any>();


    constructor(private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.translateService.onLangChange.subscribe(event => {
            this.tooltipActions.emit({action: "tooltip", params: ['']});
        });
    }

    buildTooltip(record: any) {
        switch (this.displayType) {
            case 'equipment':
                return this.buildTooltipForEquipment(record);
            case 'tools':
                return this.buildTooltipForTools(record);
            default:
                return `<div style="max-width: 300px; white-space: normal; word-wrap: break-word"> ${record}</div>`;
        }
    }

    buildTooltipForEquipment(record: Equipment) {
        let details = '';

        const linePrfx =
            this.translateService.instant('admin.partNumbers.create-modal.pick-list.equipment.tooltip.line');
        const prcsTypesPrfx =
            this.translateService.instant('admin.partNumbers.create-modal.pick-list.equipment.tooltip.processTypes');

        details = details.concat(linePrfx + record.line.name + '\n');
        details = details.concat(prcsTypesPrfx);
        for (let i = 0; i < record.processTypes.length; i++) {
            details = details.concat(' • ' + record.processTypes[i].name + '\n')
        }

        return details
    }

    buildTooltipForTools(record: string[]) {
        let details = '';

        const linePrfx = this.translateService.instant('service.tickets.details.tools.label');
        details = details.concat(linePrfx + '<br>');
        if (record && record.length !== 0) {
            for (let i = 0; i < record.length; i++) {
                details = details.concat(record[i] + '<br>')
            }
        }

        return details
    }
}
